// extracted by mini-css-extract-plugin
module.exports = {"container":"Tariffs_container__2y9ce","mobileProffit":"Tariffs_mobileProffit__3cCrq"};